// Puente entre la capa de servicios (apiClient) y el modal de confirmación de React.
// El ConfirmProvider registra aquí su función `confirmar` al montarse; el interceptor
// del apiClient la consume para pedir confirmación ante respuestas 409
// `requiere_confirmacion`, sin acoplar React a la capa de servicios.

let _confirmar = null;

export const registrarConfirmar = (fn) => {
  _confirmar = fn;
};

// Devuelve true/false. Si no hay confirm registrado (p. ej. en tests), devuelve false
// para no forzar acciones destructivas sin interacción del usuario.
export const confirmarGlobal = async (opciones) => {
  if (typeof _confirmar !== 'function') return false;
  return _confirmar(opciones);
};
